import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'Booking',
    column_type: 'id',
  },
  created_at: {
    model_name: 'Booking',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'Booking',
    column_type: 'datetime',
  },
  reference: {
    model_name: 'Booking',
    column_type: 'string',
  },
  tickets: {
    model_name: 'Booking',
    column_type: 'string',
  },
  transaction_id: {
    model_name: 'Booking',
    column_type: 'string',
  },
  status: {
    model_name: 'Booking',
    column_type: 'enum',
  },
  refund_state: {
    model_name: 'Booking',
    column_type: 'enum',
  },
  user: {
    model_name: 'Booking',
    column_type: 'belongs_to',
    extra: {
      association_name: 'user',
      model_name: 'User',
    },
  },
  user_id: {
    model_name: 'Booking',
    column_type: 'belongs_to',
    extra: {
      association_name: 'user',
      model_name: 'User',
    },
  },
  paid_at: {
    model_name: 'Booking',
    column_type: 'datetime',
  },
  last_refund_payment_status: {
    model_name: 'Booking',
    column_type: 'string',
  },
  response: {
    model_name: 'Booking',
    column_type: 'string',
  },
  real_pay_amount: {
    model_name: 'Booking',
    column_type: 'string',
  },
  payments: {
    model_name: 'Booking',
    column_type: 'has_many',
    extra: {
      association_name: 'payments',
      model_name: 'Payment',
      foreign_key: 'booking_id',
    },
  },
  payment_ids: {
    model_name: 'Booking',
    column_type: 'has_many',
    extra: {
      association_name: 'payments',
      model_name: 'Payment',
      foreign_key: 'booking_id',
    },
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
